import { Link } from "react-router-dom";

const AuthLayout = ({ children }) => {
  return (
    <>
      {children}

      <footer className="d-footer">
        <div className="row align-items-center justify-content-center justify-content-sm-between">
          <div className="col-auto">
            <Link to="/about-us" className="text-primary-600 fw-semibold">
              درباره ما
            </Link>
          </div>
          <div className="col-auto d-none">
            <p className="mb-0">
              ایجاد شده توسط{" "}
              <a
                href="https://hamzehazizzadeh.ir"
                target="_blank"
                rel="noreferrer"
                className="text-primary-600 fw-bold"
              >
                حمزه عزیززاده
              </a>
            </p>
          </div>
          <div className="col-auto">
            <a
              referrerpolicy="origin"
              target="_blank"
              href="https://trustseal.enamad.ir/?id=581802&Code=V7WhTqUbj1Oeu6GIy50jOeEguC54ikPB"
            >
              <img
                referrerpolicy="origin"
                src="https://trustseal.enamad.ir/logo.aspx?id=581802&Code=V7WhTqUbj1Oeu6GIy50jOeEguC54ikPB"
                alt=""
                style={{ width: 40, height: 40 }}
                code="V7WhTqUbj1Oeu6GIy50jOeEguC54ikPB"
              />
            </a>
          </div>
        </div>
      </footer>
    </>
  );
};

export default AuthLayout;
